import { gql } from "@apollo/client";

export const PASSWORD_LOGIN = gql`
  mutation passwordLogin($email: Email!, $password: Password!) {
    password_login(email: $email, password: $password) {
      access_token
      refresh_token
      user {
        id
        email
        mobile
        first_name
        last_name
        config {
          background_colour
        }
        profile {
          id
          url
          name
          thumbnail
          content_type
        }
        merchants {
          id
          business_type {
            id
            name
          }
          lname
          mid
          tname
        }
      }
    }
  }
`;
